import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconNote2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.5C3 4.11929 4.11929 3 5.5 3H18.5C19.8807 3 21 4.11929 21 5.5V13.1716C21 13.8346 20.7366 14.4705 20.2678 14.9393L14.9393 20.2678C14.4705 20.7366 13.8346 21 13.1716 21H5.5C4.11929 21 3 19.8807 3 18.5V5.5ZM11.5 20C12.3284 20 13 19.3284 13 18.5V15.5C13 14.1193 14.1193 13 15.5 13H18.5C19.3284 13 20 12.3284 20 11.5V5.5C20 4.67157 19.3284 4 18.5 4H5.5C4.67157 4 4 4.67157 4 5.5V18.5C4 19.3284 4.67157 20 5.5 20H11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote2;
